import * as t from "io-ts";

const HeadItem = t.type({
    boardAdminsTeachersStaff: t.number,
    parents: t.number,
    studentsAlumni: t.number,
});

const V1DomainsC = t.union([
    t.literal("practical"),
    t.literal("heart"),
    t.literal("intellectual"),
    t.literal("nurture"),
    t.literal("hands"),
    t.literal("head"),
]);

const V1PracticalC = t.union([
    t.literal("guardingTheMission"),
    t.literal("missionalHiring"),
    t.literal("specialEducationInclusion"),
    t.literal("biblicalPerspectives"),
    t.literal("equippingForGoodWork"),
    t.literal("sabbathKeeping"),
    t.literal("familyDevotions"),
    t.literal("parentalProtection"),
]);

const V1HeartC = t.union([
    t.literal("churchEngagement"),
    t.literal("personalDevotions"),
    t.literal("spiritualMaturity"),
    t.literal("hopefulness"),
    t.literal("reconciliation"),
    t.literal("reverence"),
]);

const V1HandsC = t.union([
    t.literal("devotions"),
    t.literal("readTheBible"),
    t.literal("pray"),
    t.literal("bibleStudy"),
    t.literal("religiousServices"),
]);

const V1HeadC = t.union([
    t.literal("sinsAreForgiven"),
    t.literal("createdInTheImageOfGod"),
    t.literal("inspiredWordOfGod"),
    t.literal("jesusChristIsMyLoad"),
    t.literal("marriageIsBetweenAManAndAWoman"),
    t.literal("fatherSonHolySpirit"),
    t.literal("sexOutsideOfMarriageIsSin"),
    t.literal("jesusIsSonOfGod"),
    t.literal("hopeForEternalLife"),
    t.literal("jesusIsGodAndMan"),
    t.literal("realHeaven"),
    t.literal("jesusConductedMiracles"),
    t.literal("sinceTheFall"),
    t.literal("jesusWasBornOfAVirgin"),
    t.literal("godCreatedEverything"),
    t.literal("jesusLiveASinlessLife"),
    t.literal("salvationIsOnlyPossibleThroughJesus"),
    t.literal("jesusDiedOnTheCross"),
    t.literal("bibleIsTheStandardForFaith"),
    t.literal("jesusRoseFromTheDead"),
    t.literal("churchWasEstablishedByGod"),
    t.literal("jesusWillReturn"),
    t.literal("godContinuesToBeInvolvedInTheWorld"),
    t.literal("godHatesSin"),
    t.literal("christiansAreCommanded"),
]);

const V1IntellectualC = t.union([
    t.literal("teacherWorldviewTraining"),
    t.literal("integratingFaithAndTeaching"),
    t.literal("integratingFaithAndLearning"),
    t.literal("spiritualGuidance"),
    t.literal("faithBasedAccreditation"),
    t.literal("distinctivelyChristianEducation"),
]);

const V1NurtureC = t.union([
    t.literal("spiritualGrowth"),
    t.literal("mentoringLeaders"),
    t.literal("supportiveCulture"),
    t.literal("faithfulFriends"),
    t.literal("peerEncouragement"),
    t.literal("parentalEncouragement"),
    t.literal("parentPartnership"),
    t.literal("churchSchoolCongruence"),
]);

const V1ConstructsC = t.union([
    t.literal("missionalHiring"),
    t.literal("integratingFaithAndLearning"),
    t.literal("parentalProtection"),
    t.literal("spiritualMaturity"),
    t.literal("spiritualGrowth"),
    t.literal("hopefulness"),
    t.literal("spiritualGuidance"),
    t.literal("teacherWorldviewTraining"),
    t.literal("familyDevotions"),
    t.literal("churchSchoolCongruence"),
    t.literal("mentoringLeaders"),
    t.literal("reconciliation"),
    t.literal("personalDevotions"),
    t.literal("reverence"),
    t.literal("guardingTheMission"),
    t.literal("peerEncouragement"),
    t.literal("faithBasedAccreditation"),
    t.literal("parentalEncouragement"),
    t.literal("specialEducationInclusion"),
    t.literal("parentPartnership"),
    t.literal("sabbathKeeping"),
    t.literal("faithfulFriends"),
    t.literal("distinctivelyChristianEducation"),
    t.literal("biblicalPerspectives"),
    t.literal("equippingForGoodWork"),
    t.literal("churchEngagement"),
    t.literal("integratingFaithAndTeaching"),
    t.literal("supportiveCulture"),
]);

const V1DomainConstructsC = t.type({
    domain: V1DomainsC,
    construct: V1ConstructsC,
});

const V1BenchmarksC = t.type({
    practical: t.type({
        guardingTheMission: t.number,
        missionalHiring: t.number,
        specialEducationInclusion: t.number,
        biblicalPerspectives: t.number,
        equippingForGoodWork: t.number,
        sabbathKeeping: t.number,
        familyDevotions: t.number,
        parentalProtection: t.number,
    }),
    heart: t.type({
        churchEngagement: t.number,
        personalDevotions: t.number,
        spiritualMaturity: t.number,
        hopefulness: t.number,
        reconciliation: t.number,
        reverence: t.number,
    }),
    intellectual: t.type({
        teacherWorldviewTraining: t.number,
        integratingFaithAndTeaching: t.number,
        integratingFaithAndLearning: t.number,
        spiritualGuidance: t.number,
        faithBasedAccreditation: t.number,
        distinctivelyChristianEducation: t.number,
    }),
    nurture: t.type({
        spiritualGrowth: t.number,
        mentoringLeaders: t.number,
        supportiveCulture: t.number,
        faithfulFriends: t.number,
        peerEncouragement: t.number,
        parentalEncouragement: t.number,
        parentPartnership: t.number,
        churchSchoolCongruence: t.number,
    }),
});

const V1DataC = t.type({
    practical: t.type({
        guardingTheMission: t.number,
        missionalHiring: t.number,
        specialEducationInclusion: t.number,
        biblicalPerspectives: t.number,
        equippingForGoodWork: t.number,
        sabbathKeeping: t.number,
        familyDevotions: t.number,
        parentalProtection: t.number,
    }),
    heart: t.type({
        churchEngagement: t.number,
        personalDevotions: t.number,
        spiritualMaturity: t.number,
        hopefulness: t.number,
        reconciliation: t.number,
        reverence: t.number,
    }),
    intellectual: t.type({
        teacherWorldviewTraining: t.number,
        integratingFaithAndTeaching: t.number,
        integratingFaithAndLearning: t.number,
        spiritualGuidance: t.number,
        faithBasedAccreditation: t.number,
        distinctivelyChristianEducation: t.number,
    }),
    nurture: t.type({
        spiritualGrowth: t.number,
        mentoringLeaders: t.number,
        supportiveCulture: t.number,
        faithfulFriends: t.number,
        peerEncouragement: t.number,
        parentalEncouragement: t.number,
        parentPartnership: t.number,
        churchSchoolCongruence: t.number,
    }),
    head: t.type({
        sinsAreForgiven: HeadItem,
        createdInTheImageOfGod: HeadItem,
        inspiredWordOfGod: HeadItem,
        jesusChristIsMyLoad: HeadItem,
        marriageIsBetweenAManAndAWoman: HeadItem,
        fatherSonHolySpirit: HeadItem,
        sexOutsideOfMarriageIsSin: HeadItem,
        jesusIsSonOfGod: HeadItem,
        hopeForEternalLife: HeadItem,
        jesusIsGodAndMan: HeadItem,
        realHeaven: HeadItem,
        jesusConductedMiracles: HeadItem,
        sinceTheFall: HeadItem,
        jesusWasBornOfAVirgin: HeadItem,
        godCreatedEverything: HeadItem,
        jesusLiveASinlessLife: HeadItem,
        salvationIsOnlyPossibleThroughJesus: HeadItem,
        jesusDiedOnTheCross: HeadItem,
        bibleIsTheStandardForFaith: HeadItem,
        jesusRoseFromTheDead: HeadItem,
        churchWasEstablishedByGod: HeadItem,
        jesusWillReturn: HeadItem,
        godContinuesToBeInvolvedInTheWorld: HeadItem,
        godHatesSin: HeadItem,
        christiansAreCommanded: HeadItem,
    }),
    hands: t.type({
        devotions: t.number,
        readTheBible: t.number,
        pray: t.number,
        bibleStudy: t.number,
        religiousServices: t.number,
    }),
});

const V1OpportunityC = t.intersection([
    t.type({
        title: t.string,
        prologue: t.string,
    }),
    t.partial({
        extra: t.string,
    }),
]);

const V1AreasOfImprovementC = t.type({
    practical: t.type({
        guardingTheMission: V1OpportunityC,
        missionalHiring: V1OpportunityC,
        specialEducationInclusion: V1OpportunityC,
        biblicalPerspectives: V1OpportunityC,
        equippingForGoodWork: V1OpportunityC,
        sabbathKeeping: V1OpportunityC,
        familyDevotions: V1OpportunityC,
        parentalProtection: V1OpportunityC,
    }),
    heart: t.type({
        churchEngagement: V1OpportunityC,
        personalDevotions: V1OpportunityC,
        spiritualMaturity: V1OpportunityC,
        hopefulness: V1OpportunityC,
        reconciliation: V1OpportunityC,
        reverence: V1OpportunityC,
    }),
    intellectual: t.type({
        teacherWorldviewTraining: V1OpportunityC,
        integratingFaithAndTeaching: V1OpportunityC,
        integratingFaithAndLearning: V1OpportunityC,
        spiritualGuidance: V1OpportunityC,
        faithBasedAccreditation: V1OpportunityC,
        distinctivelyChristianEducation: V1OpportunityC,
    }),
    nurture: t.type({
        spiritualGrowth: V1OpportunityC,
        mentoringLeaders: V1OpportunityC,
        supportiveCulture: V1OpportunityC,
        faithfulFriends: V1OpportunityC,
        peerEncouragement: V1OpportunityC,
        parentalEncouragement: V1OpportunityC,
        parentPartnership: V1OpportunityC,
        churchSchoolCongruence: V1OpportunityC,
    }),
});

export const V1ReportC = t.type({
    id: t.string,
    results: t.intersection([
        t.type({
            benchmarks: V1BenchmarksC,
            keyGrowthOpportunities: t.array(V1DomainConstructsC),
            meaningfulStrengths: t.array(V1DomainConstructsC),
            raw: V1DataC,
        }),
        // How the two lists were chosen; absent on reports ranked before INC-26068.
        t.partial({ ranking: t.string }),
    ]),
    version: t.literal("1"),
    year: t.string,
    type: t.string,
    surveysCompleted: t.type({
        students: t.number,
        parents: t.number,
        supportStaff: t.number,
        teachers: t.number,
        boardMembers: t.number,
        administrators: t.number,
        alumni: t.number,
    }),
    constituentGroups: t.type({
        students: t.number,
        parents: t.number,
        supportStaff: t.number,
        teachers: t.number,
        boardMembers: t.number,
        administrators: t.number,
        alumni: t.number,
    }),
});

export type V1Domains = t.TypeOf<typeof V1DomainsC>;
export type V1Practical = t.TypeOf<typeof V1PracticalC>;
export type V1Heart = t.TypeOf<typeof V1HeartC>;
export type V1Hands = t.TypeOf<typeof V1HandsC>;
export type V1Head = t.TypeOf<typeof V1HeadC>;
export type V1Intellectual = t.TypeOf<typeof V1IntellectualC>;
export type V1Nurture = t.TypeOf<typeof V1NurtureC>;
export type V1AreasOfImprovement = t.TypeOf<typeof V1AreasOfImprovementC>;

export type V1Report = t.TypeOf<typeof V1ReportC>;
export type FFIBrandedV1Report = { tag: "v1_FFI"; value: V1Report };
